import { combineReducers } from 'redux';
import location from './reducer-router';
import query from '../../contactUs/reducers/reducer-query-params';
import notifier from '../../contactUs/reducers/reducer-notifier';
import helpcenterAlerts from '../../contactUs/reducers/reducer-helpcenter-alerts';
import autoComplete from '../../contactUs/reducers/reducer-auto-complete';
import searchFilters from './reducer-search-filter-form';
import searchResult from './reducer-search-results';
import mobileFilter from './reducer-mobile-filter';
import sample from './reducer-sample';

import contentToggle from './reducer-content-toggle';
import article from '../../contactUs/reducers/reducer-active-article';
import topicList from './reducer-topic-list';
import popular from './reducer-popular-list';
import articleList from './reducer-article-list';
import breadcrumb from './reducer-breadcrumb';
import community from './reducer-community-results';


// SAMPLE APP state

// {
//   location,
//   topicTree: {
//     experience: 'personal',
//     topicTree: [],
//   },
//   topicList: {
//     experience: 'personal',
//     topicId: '',
//     topicList: [],
//   },
//   article: {
//     experience: 'personal',
//     articleId: '',
//     relatedArticle: [],
//   },
// };

const rootReducers = combineReducers({
  location,
  query,
  notifier,
  helpcenterAlerts,
  autoComplete,
  searchFilters,
  searchResult,
  mobileFilter,
  topicTree: sample,
  topicList,
  contentToggle,
  article,
  articleList,
  popular,
  breadcrumb,
  community,
});

export default rootReducers;



// WEBPACK FOOTER //
// ./home/reducers/index.js